export function money(cents: number, currency = 'RUB', from = false): string {
  const v = new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency,
    maximumFractionDigits: cents % 100 === 0 ? 0 : 2,
  }).format(cents / 100);
  return from ? `от ${v}` : v;
}

/** "1 500,50" / "1500" → копейки; null при неверном вводе */
export function parseRubles(input: string): number | null {
  const clean = input.replace(/\s/g, '').replace(',', '.');
  if (!/^\d+(\.\d{1,2})?$/.test(clean)) return null;
  return Math.round(Number(clean) * 100);
}
